import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import DurationService from "app/services/DurationService";
import { swSettings } from "app/common/services/swSettings";

export const resolveHistoricalData = () => {
    const params = proNavigator.getParams();
    const { duration, comparedDuration } = params;
    if (!duration) {
        return null;
    }
    const { from, compareFrom } = DurationService.getDurationData(duration, comparedDuration).raw;
    const absoluteStartDate = compareFrom ?? from;
    const absoluteEndDate = dayjs(swSettings?.current?.resources?.SnapshotInterval?.enddate);
    if (!absoluteEndDate || !absoluteStartDate) {
        return null;
    }
    return getDifferenceInMonths(absoluteStartDate, absoluteEndDate);
};

export const getDifferenceInMonths = (startDate: Dayjs, endDate: Dayjs): number => {
    const diffMonths = endDate.diff(startDate, "month");
    const remainingDays = endDate.diff(startDate.add(diffMonths, "month"), "day");
    return remainingDays >= 15 ? diffMonths + 1 : diffMonths;
};
